// Pick the record whose `dateField` is furthest in the future (e.g. the latest
// expiry_date), regardless of the order the records were entered in.
// Records without that date go last; ties fall back to the newest created_at.
export const latestByDate = (rows = [], dateField) =>
  [...rows].sort((a, b) => {
    const da = a?.[dateField] || '';
    const db = b?.[dateField] || '';
    if (da !== db) {
      if (!da) return 1;
      if (!db) return -1;
      return db.localeCompare(da);
    }
    return String(b?.created_at || '').localeCompare(String(a?.created_at || ''));
  })[0];
